import { initializeBookmarks } from './elements/bookmark.js';
import { initializeScheduleItemLinks } from './schedule_link.js'

document.addEventListener('DOMContentLoaded', () => {
  initializeBookmarks();
  initializeScheduleItemLinks();
  initializeScheduleBlock();
});

const schedulePageBlockClass = 'Block--schedulePage';

function initializeScheduleBlock() {
  const $schedulePageBlock = document.querySelector(`.${schedulePageBlockClass}`);

  if(!$schedulePageBlock) {
    return;
  }

  let isDown = false;
  let startX;
  let scrollLeft;

  $schedulePageBlock.addEventListener('pointerdown', (event) => {
    let $slide = event.target.closest('.Schedule__Track__Slide');

    if (!$slide || !$schedulePageBlock.contains($slide)) {
      return;
    }

    $schedulePageBlock.querySelectorAll('.Schedule__Track__Slide').forEach($slide => {
      isDown = true;
      $slide.classList.add('active');
      startX = event.pageX - $slide.offsetLeft;
      scrollLeft = $slide.scrollLeft;
    });
  });

  document.addEventListener('pointerup', () => {
    $schedulePageBlock.querySelectorAll('.Schedule__Track__Slide').forEach(slide => {
      isDown = false;
      slide.classList.remove('active');
    });
  });

  document.addEventListener('pointermove', (event) => {
    if (!isDown) {
      return;
    }

    $schedulePageBlock.querySelectorAll('.Schedule__Track__Slide').forEach(slide => {
      event.preventDefault();
      const x = event.pageX - slide.offsetLeft;
      const walk = x - startX;
      slide.scrollLeft = scrollLeft - walk;
    });
  });
}
